import {
  useI18n
} from "@/composables/useI18n";
import {ref, Ref} from "vue";
const useSnackbar = (snackbarRef: Ref) => {
  const {
    t,
    tc,
  } = useI18n()

  const snackbarStatus = ref('');
  const snackbarText = ref<string[]>([]);

  type OperationActionMap = (operationType: string) => string;

  const showSnackbar = (
    {
      status = undefined,
      statusText = undefined
    }: {
      status?: string,
      statusText?: string[]
    }
  ) => {
    snackbarStatus.value = status ? status : 'success';
    snackbarText.value = statusText ? statusText : [t('success')];

    (snackbarRef.value as any).show();
  };

  const showSnackbarResponse = (response: Record<any, any>, callback: OperationActionMap) => {

    const { successfulItems, failedItems, operationType } = response;

    const action = callback(operationType);

    let statusText = [];
    let status = 'success';

    if (successfulItems.length > 0) {
      const count = successfulItems.length;
      statusText.push(tc('successful_items', count, { action: action }) as string);
    }

    if (failedItems.length > 0) {
      status = 'orange darken-1';
      const count = failedItems.length;
      statusText.push(tc('failed_items', count, { action: action }) as string);
    }

    showSnackbar({status, statusText})
  }

  return {
    snackbarStatus,
    snackbarText,
    showSnackbarResponse: showSnackbarResponse,
    showSnackbar,
  }

}


export {
  useSnackbar
}
